import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_ARENDA_ZVUKA: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Все проводные и&nbsp;беспроводные микрофоны подключаются в&nbsp;микшерный пульт звукооператора',
            alt: 'Микшерный пульт звукооператора',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/mixing-console-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/mixing-console.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/mixing-console-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/mixing-console.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Звукорежиссер внимательно следит, чтобы голос выступающих был слышен на&nbsp;комфортной для всех громкости, и&nbsp;не&nbsp;допускает &laquo;свистов&raquo; и&nbsp;&laquo;заводок&raquo; микрофонов',
            alt: 'Звукорежиссер внимательно следит за голосом выступающих',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/engineer-controls-sound-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/engineer-controls-sound.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/engineer-controls-sound-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/engineer-controls-sound.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. Помимо основной акустической системы зала, звук поступает переводчикам в&nbsp;кабину и&nbsp;на&nbsp;запись, если есть такая необходимость',
            alt: 'Поступление звука переводчикам',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters-drawing.png',
            image_webp:
                '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters.png',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'А как в работе',
        description: 'Видеотрансляция на мероприятии с оборудованием от Cromi',
        width: 400,
        height: 230,
        video_preview:
            '/assets/images/usage/sound/jpg-png/audio-broadcasting.png',
        video_preview_webp:
            '/assets/images/usage/sound/webp/audio-broadcasting.webp',
        duration: '1:53',
        link: '73d10bcde26b9a3ba106c58fa37cecc5',
    },
}

export default HOW_IT_WORK_ARENDA_ZVUKA
